import './_header.scss'
import React, { useContext, useState } from 'react';
import { Button, ControlLabel, FormControl } from 'react-bootstrap';

import { Context } from '../../index';
import AlertComponent from '../../../../../../components/Alert';
import { getErrorMessage } from '../../../../../../utils/helper';
import { servicesHideHide } from '../../../../../../services/endpoints/services';
import { listUpdate } from '../../reducer';
import Wall from '../../../components/Wall';

const HideServicesHeader = () => {
  const [, dispatch] = useContext(Context);
  const [serviceId, setServiceId] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const onChange = (e) => {
    const value = e.target.value;
    if (/^[0-9\b, ]+$/.test(value) || !value) {
      setServiceId(value)
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true)
      await servicesHideHide(serviceId);
      setError(null);
      dispatch(listUpdate())
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage)
    } finally {
      setLoading(false);
      setServiceId('');
    }
  }

  return (
    <Wall>
      <div>
        {isLoading ? <div className="modal-loader-small" /> : null }
        {error ? <AlertComponent text={error} /> : null }
        <ControlLabel>Hide for users</ControlLabel>
        <form onSubmit={onSubmit} className="services-hide__header-row">
          <FormControl
            type="text"
            disabled={isLoading}
            value={serviceId}
            placeholder="Service ID separated by commas (e.g., 145, 384, 2563)"
            onChange={onChange}
          />
          <Button
            type="submit"
            bsStyle="primary"
            disabled={isLoading}
          >
            Hide
          </Button>
        </form>
      </div>
    </Wall>
  );
};

HideServicesHeader.propTypes = {

};

export default HideServicesHeader;
